import * as actions from 'actions/deviceTesting';
import {
  DEVICE_STATUS_TESTED,
  DEVICE_STATUS_ACTIVE,
} from 'xm-constants/device';

function trySyncDeviceTestedStatusWithGwt(deviceId) {
  window.fireGWTMarkDeviceTested?.(deviceId);
}

export default function deviceReducer(state = {}, action) {
  switch (action.type) {
    case actions.DEVICE_TESTING_ADD_DEVICE:
      return { ...state, ...action.payload };
    case actions.MARK_DEVICE_AS_TESTED_SUCCESS:
      // device has been marked as tested - sync state change to GWT
      trySyncDeviceTestedStatusWithGwt(action.payload.id);
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          tested: true,
          pending: false,
          active: true,
        },
      };
    case actions.SEND_TEST_MESSAGE_START:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          tested: false,
          pending: true,
        },
      };
    case actions.SEND_TEST_MESSAGE_FAIL:
      return {
        ...state,
        [action.initialPayload]: {
          ...state[action.initialPayload],
          tested: false,
          pending: false,
        },
      };
    case actions.DEVICE_TESTING_CLEAR_PENDING:
      return {
        ...state,
        [action.payload.deviceId]: {
          ...state[action.initialPayload],
          tested: action.payload.tested,
          pending: false,
        },
      };
    case actions.IS_DEVICE_TESTED_SUCCESS: {
      const newState = { ...state };

      action.payload.data.forEach(device => {
        if (!newState[device.id]) {
          return;
        }

        newState[device.id] = {
          pending:
            device.testStatus === DEVICE_STATUS_TESTED
              ? false
              : newState[device.id].pending,
          tested: device.testStatus === DEVICE_STATUS_TESTED,
          active: device.status === DEVICE_STATUS_ACTIVE,
        };

        if (!{ ...state }[device.id].tested && newState[device.id].tested) {
          // device has gone from untested to tested - sync state change to GWT
          trySyncDeviceTestedStatusWithGwt(device.id);
        }
      });

      return newState;
    }
    default:
      return state;
  }
}
